import React from 'react';

import { StyleSheet, View } from 'react-native';

import LoadingAnimation from 'components/loading-animation';
import { Skeleton } from 'components/ui/skeleton';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

const SKELETON_IMAGE_WIDTH = 104;

const MenuTileSkeleton = () => {
  return (
    <View style={styles.container}>
      <View style={styles.image}>
        <Skeleton
          shape="square"
          style={{ width: SKELETON_IMAGE_WIDTH, height: SKELETON_IMAGE_WIDTH }}
        />
      </View>
      <View style={styles.content}>
        <Skeleton shape="rectangle" style={{ width: '85%', height: spacing.$4 }} />
      </View>
    </View>
  );
};

export const MenuSkeletonLoader = () => {
  const isMobile = useIsMobileBreakpoint();

  if (isMobile) {
    return (
      <>
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
        <MenuTileSkeleton />
      </>
    );
  }

  return <LoadingAnimation />;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$2,
    alignContent: 'center',
  },
  image: {
    width: SKELETON_IMAGE_WIDTH,
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    padding: spacing.$4,
  },
});
